import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import {Dog} from '../Experience/Dog';

export const ContactForm = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_l4rbjop",
        "template_e1ds2lo",
        form.current,
        "5oSt7CsiLyWp11-1t"
      )
      .then(
        (result) => {
          console.log(result.text);
          console.log("message sent")
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <form
      ref={form}
      onSubmit={sendEmail}
      className=" flex flex-col text-white gap-1 mx-3"
    >
    
      <label>Name*</label>
      <input type="text" name="user_name" className=" rounded-2xl py-2 pl-2 border-4 border-pink-600 bg-transparent md:w-1/2 w-auto" />
      <label>Email*</label>
      <input type="email" name="user_email" className="rounded-2xl py-2 pl-2 border-4 border-pink-600 bg-transparent md:w-1/2 w-auto" />
      <label>Message*</label>
      <textarea name="message" className="rounded-2xl py-2 pl-2 bg-transparent border-4 border-pink-600" />
      <input
        type="submit"
        value="Send"
        className=" border-4 border-indigo-600 w-1/3 mt-2 rounded-2xl mb-6 hover:border-white hover:text-pink-400 "
        /><div className="absolute right-60"><Dog /></div>
      
    </form>
  );
};
